
import React from 'react';

interface ProcessStepProps {
  number: string;
  title: string;
  description: string;
}

const ProcessStep = ({ number, title, description }: ProcessStepProps) => {
  return (
    <div className="flex gap-6 md:gap-10 mb-12 md:mb-16">
      <div className="flex-shrink-0">
        <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-3xl md:text-4xl font-bold">
          {number}
        </div>
      </div>
      <div>
        <h3 className="text-xl md:text-2xl font-bold mb-3 text-white">{title}</h3>
        <p className="text-white/80">{description}</p>
      </div>
    </div>
  );
};

const StrategyProcess = () => {
  return (
    <section className="py-20 px-6 bg-gradient-to-b from-background to-background/90">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            Our Proven <span className="text-gradient">3-Step Strategy</span> Process
          </h2>
          <p className="text-lg text-white/80">
            Simple. Customized. Real-world results for legal practices.
          </p>
        </div>
        
        <div className="mt-12 max-w-3xl mx-auto">
          <ProcessStep 
            number="①"
            title="Discovery Session"
            description="Understand Your Firm's Goals and Challenges. We begin with a collaborative session to deeply understand your firm's practice areas, client needs, operational challenges, and growth ambitions — so your AI strategy is tailored from the very start."
          />
          
          <ProcessStep 
            number="②"
            title="Roadmap Development"
            description="Design Your Firm's Custom AI Strategy. We translate insights into a practical, detailed roadmap — highlighting opportunities, managing risks, and giving your firm a clear action plan to move forward with confidence."
          />
          
          <ProcessStep 
            number="③"
            title="Advisory Support"
            description="Support Your Journey from Planning to Execution. After delivering your roadmap, we stay engaged to offer follow-up advisory, resources, and expert coaching — helping you drive real results as you implement."
          />
        </div>
      </div>
    </section>
  );
};

export default StrategyProcess;
